<template>
  <div>
    <b-row >
      <b-col style="text-align: left">
        <span class="entity-data-label">
          {{ prefix }} Address:
        </span>
      </b-col>
      <b-col style="text-align: left">
      <span class="entity-data-value">
        {{ address.address || '-' }}
      </span>
      </b-col>
    </b-row>
    <b-row >
      <b-col style="text-align: left">
        <span class="entity-data-label">
          {{ prefix }} City:
        </span>
      </b-col>
      <b-col style="text-align: left">
      <span class="entity-data-value">
        {{ address.city || '-' }}
      </span>
      </b-col>
    </b-row>
    <b-row >
      <b-col style="text-align: left">
        <span class="entity-data-label">
          {{ prefix || '-' }} State:
        </span>
      </b-col>
      <b-col style="text-align: left">
      <span class="entity-data-value">
        {{ address.state || '-' }}
      </span>
      </b-col>
    </b-row>
    <b-row >
      <b-col style="text-align: left">
        <span class="entity-data-label">
          {{ prefix }} Zip Code:
        </span>
      </b-col>
      <b-col style="text-align: left">
      <span class="entity-data-value">
        {{ address.zipCode || '-' }}
      </span>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: 'EntitySummaryAddress',
  props: {
    address: Object,
    prefix: String,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/entities/EntitySummaryAddress.vue